import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { withTracking } from '../ReactGAUtils/ReactGAUtils'

const InternalLink = ({ to, sendEvent, ...props }) => {
  if (typeof to === 'string') {
    to = { pathname: to }
  }
  return (
    <Link
      onClick={() => sendEvent()}
      {...props}
      to={{
        ...to,
        state: {
          ...to.state,
          internal: true
        }
      }}
    />
  )
}

InternalLink.propTypes = {
  to: PropTypes.any,
  sendEvent: PropTypes.func
}

export default withTracking(InternalLink)
